



























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import Api from "@/api";
import swal from "sweetalert";
import FormErrorsMixin from "@/mixins/FormErrors";
import Multiselect from "vue-multiselect";

import ViewLoader from "@/components/Common/ViewLoader.vue";
import TextInput from "@/components/Common/Inputs/TextInput.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import WarningButton from "@/components/Common/Buttons/WarningButton.vue";
import DangerButton from "@/components/Common/Buttons/DangerButton.vue";
import NavigationTabs from "@/components/Settings/Events/NavigationTabs.vue";
import Error404 from "@/components/Common/Error404.vue";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { ICategory, IInstructor } from "@/interface";
import { AxiosResponse } from "axios";
import { quillEditor } from "vue-quill-editor";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    TextInput,
    InfoButton,
    WarningButton,
    DangerButton,
    NavigationTabs,
    Multiselect,
    quillEditor,
    Error404
  }
})
export default class Instructor extends Mixins(FormErrorsMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = [
    "name",
    "email",
    "display_phone_number",
    "display_email",
    "website",
    "facebook_link",
    "youtube_link",
    "twitter_link",
    "note",
    "phone_number.prefix",
    "phone_number.number",
    "category_ids"
  ];
  private noDataExist = false;
  private instructorHideCustomersMenu = false;
  private instructorHideCustomersMenuInput = "";
  private instructorImageRemovable = true;
  private userMgmtAccess = true;
  private readWriteAccess = true;
  private settingsAccess = true;
  private hasAccount = true;
  private hasOperator = true;
  private isDeletable = true;
  private originalName: string | null = null;
  private status: string | null = null;
  private selectedInstructor: IInstructor = {
    //gender: null,
    //title: null,
    name: null,
    email: null,
    display_email: true,
    display_phone_number: false,
    website: null,
    facebook_link: null,
    youtube_link: null,
    twitter_link: null,
    note: null,
    description: null,
    phone_number: {
      prefix: null,
      number: null
    },
    category_ids: []
  };
  private selectedInstructorId: string | null = null;
  private failedRequest = false;
  private allCategories: Array<ICategory> = [
    //
  ];
  private categoryValue: Array<ICategory> = [
    //
  ];
  private categoryOptions: Array<ICategory> = [
    //
  ];
  private editorOptions: any = {
    modules: {
      toolbar: [
        ["bold", "italic", "underline", "strike"],
        ["blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        [{ size: ["small", false, "large", "huge"] }],
        [{ font: [] }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ["link"]
      ]
    }
  };
  private placeHolderUrl = require("@/assets/img/icon-user.png");
  private url = require("@/assets/img/icon-user.png");
  private newUrl: File | string | null = null;
  private originalProfileImageUrl: File | null = null;
  private profileImage: File | null = null;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.getCategories();
      vm.selectedInstructorId = vm.$route.params.instructor_id;
      if (
        typeof vm.selectedInstructorId !== "undefined" &&
        vm.selectedInstructorId !== null
      ) {
        if (vm.$route.query.instructor_created === "true") {
          swal("Success!", "The instructor was created.", "success").then(
            () => {
              window.history.pushState(
                {},
                document.title,
                window.location.pathname
              );
            }
          );
        }
        vm.getInstructor();
      } else {
        vm.newUrl = vm.placeHolderUrl;
      }
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    this.getCategories();
    if (
      typeof this.selectedInstructorId !== "undefined" &&
      this.selectedInstructorId !== null
    ) {
      this.getInstructor();
    } else {
      this.newUrl = this.placeHolderUrl;
    }
    next();
  }

  private addCategory(category: ICategory): void {
    if (!this.categoryValue.some(c => c.id == category.id)) {
      this.categoryValue.push(category);
    }
  }

  private getCategories(successCallback?: any): void {
    this.loading = true;
    this.allCategories = [];
    const endpoint: string = this.$partnerEndpoint("categories");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.allCategories = response.data.data;
        this.failedRequest = false;
        for (let i = 0; i < this.allCategories.length; i++) {
          this.categoryOptions.push({
            name: this.allCategories[i].name,
            id: this.allCategories[i].id
          });
        }
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch(() => {
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private createOrUpdateInstructor(): void {
    if (this.selectedInstructorId == null) {
      this.createInstructor();
    } else {
      this.updateInstructor();
    }
  }

  private createInstructor(): void {
    if (this.updating) {
      return;
    }

    if (
      this.categoryValue != null &&
      this.categoryValue.length > 0 &&
      this.selectedInstructor.category_ids
    ) {
      for (let i = 0; i < this.categoryValue.length; i++) {
        this.selectedInstructor.category_ids.push(this.categoryValue[i].id);
      }
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint("instructors");

    Api()
      .post(endpoint, this.selectedInstructor)
      .then((response: AxiosResponse) => {
        this.selectedInstructorId = response.data.data.id;
        if (
          this.originalProfileImageUrl != this.url &&
          this.url != null &&
          this.url != this.placeHolderUrl
        ) {
          this.updateInstructorProfileImage("create");
        } else {
          this.$router.push({
            name: "EventInstructorDetails",
            params: { instructor_id: `${this.selectedInstructorId}` },
            query: { instructor_created: "true" }
          });
        }
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#instructor-name", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private getInstructor(successCallback?: any): void {
    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "instructors/" + this.selectedInstructorId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedInstructor = response.data.data;
        if (this.selectedInstructor.name) {
          this.originalName = this.selectedInstructor.name;
        }
        if (this.selectedInstructor.status) {
          this.status = this.selectedInstructor.status;
        }
        if (this.selectedInstructor.categories) {
          for (var i = 0; i < this.selectedInstructor.categories.length; i++) {
            let cat = {
              id: this.selectedInstructor.categories[i].id,
              name: this.selectedInstructor.categories[i].name
            };
            this.addCategory(cat);
          }
        }
        if (response.data.data.profile_image != null) {
          this.url = response.data.data.profile_image;
          this.originalProfileImageUrl = this.url;
          this.newUrl = this.url;
        } else {
          this.newUrl = this.placeHolderUrl;
        }
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
        if (
          this.selectedInstructor != null &&
          this.selectedInstructor.categories != null &&
          this.selectedInstructor.categories.length > 0
        ) {
          for (let i = 0; i < this.allCategories.length; i++) {
            for (
              let j = 0;
              j < this.selectedInstructor.categories.length;
              j++
            ) {
              if (
                this.selectedInstructor.categories[j].id ==
                this.allCategories[i].id
              ) {
                this.addCategory({
                  name: this.allCategories[i].name,
                  id: this.allCategories[i].id
                });
              }
            }
          }
        }
      });
  }

  private updateInstructor(): void {
    if (this.loading || this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "instructors/" + this.selectedInstructorId
    );

    this.selectedInstructor.category_ids = [];
    if (this.categoryValue != null && this.categoryValue.length > 0) {
      for (let i = 0; i < this.categoryValue.length; i++) {
        this.selectedInstructor.category_ids.push(this.categoryValue[i].id);
      }
    }

    delete this.selectedInstructor.profile_image;
    delete this.selectedInstructor.categories;

    Api()
      .put(endpoint, this.selectedInstructor)
      .then(() => {
        if (
          this.originalProfileImageUrl != this.url &&
          this.url != null &&
          this.url != this.placeHolderUrl
        ) {
          this.updateInstructorProfileImage("update");
        } else {
          this.getInstructor(() => {
            //
          });
        }
        swal({
          title: "Success!",
          text: "The instructor was updated.",
          icon: "success"
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#instructor-name", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private deleteInstructor(): void {
    if (this.loading || this.updating) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The instructor will be deleted",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "instructors/" + this.selectedInstructorId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router.push({
              name: "EventInstructors",
              query: { instructor_deleted: "true" }
            });
          })
          .catch((error: any) => {
            console.log(error.response);
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete instructors.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private updateInstructorProfileImage(origin: string): void {
    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "instructors/" + this.selectedInstructorId + "/profile-image"
    );

    let formData = new FormData();
    if (this.profileImage != null) {
      formData.append("profile_image", this.profileImage);
      formData.append("_method", "put");
    } else {
      return;
    }

    Api()
      .post(endpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then((response: AxiosResponse) => {
        console.log(response);

        if (origin == "create") {
          this.$router.push({
            name: "EventInstructorDetails",
            params: { instructor_id: `${this.selectedInstructorId}` },
            query: { instructor_created: "true" }
          });
        }
        if (origin == "update") {
          swal({
            title: "Success!",
            text: "The instructor was updated.",
            icon: "success"
          });
        }
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#instructor-name", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private deleteInstructorProfileImage(): void {
    swal({
      title: "Are you sure?",
      text: "The profile image will be deleted",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        /*const endpoint = this.$partnerEndpoint('instructors/' + this.selectedInstructorId  + '/profile-image');

        Api().delete(endpoint)
          .then(() => {
            this.url = this.placeHolderUrl;
            this.newUrl = this.placeHolderUrl;
            this.profileImage = null;
            swal({
              title: 'Success!',
              text: 'The profile image was deleted',
              icon: 'success',
            });
          })
          .catch((error) => {
            console.log(error.response);
            if (error.response.status === 403) {
              swal({
                title: 'Missing permission',
                text: 'You are not allowed to delete the profile image.',
                icon: 'error',
                //dangerMode: true,
              });
            }
          });*/
      } else {
        //
      }
    });
  }

  private onFileChange(e: any): void {
    const file = e.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file);
    this.newUrl = URL.createObjectURL(file);
  }

  private onUpdateInstructorProfileImage(): void {
    this.url = this.newUrl;
    // this.profileImage = this.$refs.profileImage.files[0];
  }

  private onDeleteInstructorProfileImage(): void {
    this.deleteInstructorProfileImage();
  }

  get editor(): any {
    return (this.$refs.instructorDescriptionEditor as any).quill;
  }
}
